export function capitalizeFirstLetter(text) {

    const capitalizedText = text && text.charAt(0).toUpperCase() + text.slice(1);

    return capitalizedText;
}